module.exports = __webpack_public_path__ + "img/anemometro.160244fb.webp";